import React from 'react';
import ProcessSection from "./ProcessContents/ProcessSection"
import ProcessHeader from "./ProcessContents/ProcessHeader"
import VerifyAccount from './VerifyAccount';
import AutoNotfication from './AutoNotfication';
 




   

function Process(){


  

    return(


        <div className='main-con-process-content'>

        <div className="inner-main-con-process-content grid font-mono">
      {/*    <VerifyAccount /> */}
         <AutoNotfication />
        <ProcessSection/>
        <ProcessHeader/>
       
         
        </div>
        </div>
    )






}



export default  Process